import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.css']
})
export class StepperComponent implements OnInit {
  @Input() step: string;

  constructor() { }

  ngOnInit(): void {
    const bodyEL = document.getElementsByTagName('body')[0]
    const curStep = this.step
    if ( curStep === 'step1') {
      bodyEL.classList.add(curStep)
      bodyEL.classList.replace('step2', curStep)
    } else if (curStep === 'step2') {
      bodyEL.classList.replace('step1', curStep)
      bodyEL.classList.replace('step3', curStep)
    } else if (curStep === 'step3') {
      bodyEL.classList.replace('step2', curStep)
    } else if (curStep === 'step4') {
      bodyEL.classList.add(curStep)
    }
  }

}
